import * as React from "react";
import { ModalData } from "store/modules/DialogStore";
import { AppButton } from "components/AppButton";

import styles from "./AppDialog.module.scss";
import { AppModal } from "components/AppModal/AppModal";

interface Props {
  onClose?(): void;
  data: ModalData;
}
export const AppDialog: React.FC<Props> = ({ data, onClose }) => {
  return (
    <AppModal title={data.title} onClose={onClose}>
      <div className={styles.container}>
        {data.icon ? <div className={styles.icon}>{data.icon}</div> : null}
        <div className={styles.description}>{data.description}</div>
        <div className={styles.buttons}>
          {data.buttons?.map((item, index) => {
            return (
              <AppButton
                key={index}
                variant={item.variant || "siren"}
                onClick={item.onClick || onClose}
              >
                {item.text}
              </AppButton>
            );
          })}
        </div>
      </div>
    </AppModal>
  );
};
